"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachClient = /*#__PURE__*/function () {
  function CoachClient(client) {
    (0, _classCallCheck2["default"])(this, CoachClient);
    this.client = client;
    this.resourceUrl = '/client';
  }

  (0, _createClass2["default"])(CoachClient, [{
    key: "getClientList",
    value: function getClientList() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl), args);
    }
  }, {
    key: "getClientProfile",
    value: function getClientProfile(clientId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(clientId), args);
    }
  }, {
    key: "getUserComparisonReport",
    value: function getUserComparisonReport(clientId, data, surveyType) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        args[_key3 - 3] = arguments[_key3];
      }

      return this.client.post("/survey/compare/client/".concat(clientId, "?surveyType=").concat(surveyType), data, args);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(userId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("/user/".concat(userId), args);
    }
  }, {
    key: "sessionCreate",
    value: function sessionCreate(clientId, data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.post("/session/client/".concat(clientId), data, args);
    }
  }, {
    key: "sessionUpdate",
    value: function sessionUpdate(clientId, sessionId, data) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
        args[_key6 - 3] = arguments[_key6];
      }

      return this.client.put("/session/".concat(sessionId), data, args);
    }
  }, {
    key: "getUserSurveyById",
    value: function getUserSurveyById(id) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.get("/survey/".concat(id), args);
    }
  }, {
    key: "getUserSurveyResult",
    value: function getUserSurveyResult(surveyId, clientId, surveyType) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
        args[_key8 - 3] = arguments[_key8];
      }

      return this.client.get("/survey/".concat(surveyId, "/client/").concat(clientId).concat(surveyType ? "?surveyType=".concat(surveyType) : ''), args);
    }
  }, {
    key: "getIntentions",
    value: function getIntentions(userId, data) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      return this.client.post("/intention/user/".concat(userId), data, args);
    }
  }, {
    key: "getClientSimple360",
    value: function getClientSimple360(clientId) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.get("/survey-request/client/".concat(clientId, "/360-answers"), args);
    }
  }]);
  return CoachClient;
}();

exports["default"] = CoachClient;